// Pill.js — v3 status / category chip. Fully round, 11–12px.
// Maps semantic quote + proposal status names AND raw color names to the v3
// status color pairs. The status→color mapping mirrors statusPill() in
// styleTokens.js exactly, so status colors stay identical to the rest of the
// app (design-system-binding §1). Faithful port of components/core/Pill.jsx.
import React from 'react';
import { v3 } from '../../lib/styleTokens';

const S = v3.color.status;

// variant → [bg, fg]. Status names + generic color names + the ink accent.
const VARIANTS = {
  // Quote / proposal status names (mirror statusPill() in styleTokens.js)
  draft:           [S.grayBg,  S.grayText],
  sent_for_review: [S.blueBg,  S.blueText],
  sent:            [S.blueBg,  S.blueText],
  in_review:       [S.blueBg,  S.blueText],
  viewed:          [S.amberBg, S.amberText],
  approved:        [S.greenBg, S.greenText],
  won:             [S.greenBg, S.greenText],
  declined:        [S.redBg,   S.redText],
  lost:            [S.redBg,   S.redText],
  expired:         [S.amberBg, S.amberText],
  superseded:      [S.grayBg,  S.grayText],
  // Generic color variants
  amber: [S.amberBg, S.amberText],
  green: [S.greenBg, S.greenText],
  red:   [S.redBg,   S.redText],
  blue:  [S.blueBg,  S.blueText],
  gray:  [S.grayBg,  S.grayText],
  ink:   [v3.color.inkBg, v3.color.ink],
};

export function Pill({ variant = 'gray', size = 'sm', children, style = {} }) {
  const [bg, fg] = VARIANTS[variant] || VARIANTS.gray;
  const lg = size === 'lg';
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: lg ? '4px 10px' : '2px 8px',
        borderRadius: v3.radius.pill,
        background: bg,
        color: fg,
        fontFamily: v3.font.family,
        fontSize: lg ? v3.font.size.small : v3.font.size.micro,
        fontWeight: v3.font.weight.semibold,
        letterSpacing: '0.1px',
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {children}
    </span>
  );
}
